import { useQuery } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

export const useQueryMasters = () => {
  return useQuery({
    queryKey: queryKeys.masters,
    queryFn: () => baseClient.getApi(MasterApi).getMasters(),
  })
}
